import icon from "images/icons/icon-trigger.svg"

export default function TriggerIcon({ title }) {
  return (
    <span
      className="svg-icon"
      title={title}
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  )
}
